/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface GetOrderResponseDataContactsRepresentativePhonesInner {
  /**
   * contactsのID
   */
  id?: string;
  /**
   * 電話番号種別<br/> H：自宅、M：携帯、B：会社
   */
  type?: GetOrderResponseDataContactsRepresentativePhonesInner.TypeEnum;
  /**
   * DxAPIから返却された国番号から\"+\"を除いた文字列。<br/> リクエストパラメータのマスキング要否がtrueの場合、返却しない
   */
  countryPhoneExtension?: string;
  /**
   * DxAPIから返却された電話番号。末尾に「/CTC HERE」がある場合はそれを除いた文字列。<br/> リクエストパラメータのマスキング要否がtrueの場合、下3桁以外をアスタリスクでマスキングした文字列。<br/> falseの場合、加工なしの文字列で返却する
   */
  number?: string;
  /**
   * 暗号化済み電話番号。リクエストパラメータのマスキング要否がtrueの場合のみ値を返却する。<br/> ※暗号化についてはAES方式とし、G03_共通処理（514_暗号化）を利用する。
   */
  encryptedNumber?: string;
}
export namespace GetOrderResponseDataContactsRepresentativePhonesInner {
  export type TypeEnum = 'H' | 'M' | 'B';
  export const TypeEnum = {
    H: 'H' as TypeEnum,
    M: 'M' as TypeEnum,
    B: 'B' as TypeEnum,
  };
}
